<template>
  <div>
    <div class="mb-1"><label v-translate translate-context="event_wizard.invite.credentials">Username</label>: {{ credentials.username }}
      <CLink class="ml-2"
             @click="copyInClipboard(credentials.username, $pgettext('event_wizard.invite.credentials','Username'))">
        <CIcon name="cipCopy" size="custom-size" :height="18"/>
      </CLink>
    </div>
    <div class="mb-1"><label v-translate translate-context="event_wizard.invite.credentials">Password</label>: {{ credentials.password }}
      <CLink class="ml-2"
             @click="copyInClipboard(credentials.password, $pgettext('event_wizard.invite.credentials','Password'))">
        <CIcon name="cipCopy" size="custom-size" :height="18"/>
      </CLink>
    </div>
  </div>
</template>

<script>
export default {
  name: "FtpCredential",
  props: {
    credentials: Object
  },
  methods: {}
}
</script>


<style scoped>

</style>